/* tslint:disable */
 
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum OrganizationSizeEnum {
  SIZE_MAX_1000 = "SIZE_MAX_1000",
  SIZE_MAX_250 = "SIZE_MAX_250",
  SIZE_MORE_THAN_1000 = "SIZE_MORE_THAN_1000",
}

export enum OriginRequestEnum {
  BLOG = "BLOG",
  EDUCATION = "EDUCATION",
  REFERRALS = "REFERRALS",
  RESOURCES = "RESOURCES",
}

export interface CreateRequestDemoPhoneNumberInput {
  requestDemo?: RequestDemoPhoneNumberCreateInput | null;
  clientMutationId?: string | null;
}

export interface CreateRequestDemoResourcesInput {
  requestDemo?: RequestDemoResourcesCreateInput | null;
  clientMutationId?: string | null;
}

export interface RequestDemoPhoneNumberCreateInput {
  phoneNumber: string;
}

export interface RequestDemoResourcesCreateInput {
  lastName: string;
  name: string;
  email: string;
  company?: string | null;
  role?: string | null;
  country?: string | null;
  organizationSize?: OrganizationSizeEnum | null;
  phoneNumber?: string | null;
  descriptionCompany?: string | null;
  origin?: OriginRequestEnum | null;
  utmSource?: string | null;
  utmMedium?: string | null;
  utmCampaign?: string | null;
  utmTerm?: string | null;
  utmContent?: string | null;
  gclid?: string | null;
  fbclid?: string | null;
  resourceId?: number | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
